import iconEmerg from '../../../domain/assets/img_emerg.svg';
import styles from './index.module.scss';
import SVG from 'react-inlinesvg';

interface props {
  title: string | undefined;
  content: string | undefined;
}

const Maintenance = ({ title, content }: props) => {
  const contentText =
    content && content.length !== 0 ? content.split('\n') : [];

  return (
    <div className={styles['maintenance']}>
      <div className={styles['main']}>
        <img className={styles['emerg']} src={iconEmerg} alt="emerg" />
        <h1>{title}</h1>
        <p>
          {contentText.map((t) => (
            <>
              {t}
              <br />
            </>
          ))}
        </p>
      </div>
      <SVG className={styles['footer']} src="/assets/pba_light.svg" />
    </div>
  );
};

export default Maintenance;
